module.exports = __webpack_public_path__ + "static/media/1.12987d89.jpeg";